// src/components/BottomBar/BottomBar.jsx
import React, { useMemo, useState } from "react";
import {
  IconHome,
  IconPlus,
  IconList,
  IconTool,
  IconCart,
} from "../Icons/Icons";
import { NIVEIS } from "../../config/niveis";

function BottomBar({ usuario, abaAtiva = "home", onNavigate, badges = {} }) {
  const [ripple, setRipple] = useState(null);

  const flags = useMemo(() => {
    const nivel = Number(usuario?.nivel ?? -1);
    return {
      isCliente: nivel === NIVEIS.CLIENTE,
      isKiosk: nivel === NIVEIS.KIOSK,
    };
  }, [usuario]);

  const handleClick = (aba, rota) => {
    setRipple(aba);
    setTimeout(() => setRipple(null), 400);
    onNavigate && onNavigate(rota);
  };

  const renderBadge = (count) => {
    if (!count || count <= 0) return null;
    return <span className="m-bottom-badge">{count > 99 ? "99+" : count}</span>;
  };

  // Kiosk: sem barra inferior (fluxo travado em abrir OS)
  if (flags.isKiosk) return null;

  return (
    <nav className="m-bottom-bar">
      {/* Home (some para Cliente) */}
      {!flags.isCliente && (
        <button
          className={`m-bottom-btn ${abaAtiva === "home" ? "ativo" : ""} ${
            ripple === "home" ? "ripple" : ""
          }`}
          onClick={() => handleClick("home", "/")}
        >
          <span className="m-bottom-icon">
            <IconHome size="22px" />
          </span>
          <span className="m-bottom-label">Home</span>
          {renderBadge(badges.home)}
        </button>
      )}

      {/* Ordens (sempre) */}
      <button
        className={`m-bottom-btn ${abaAtiva === "ordens" ? "ativo" : ""} ${
          ripple === "ordens" ? "ripple" : ""
        }`}
        onClick={() => handleClick("ordens", "/ordens-servico")}
      >
        <span className="m-bottom-icon">
          <IconList size="22px" />
        </span>
        <span className="m-bottom-label">Ordens</span>
        {renderBadge(badges.ordens)}
      </button>

      {/* FAB Central - Abrir OS */}
      <button
        className={`m-bottom-fab ${abaAtiva === "abrir" ? "ativo" : ""} ${
          ripple === "abrir" ? "ripple" : ""
        }`}
        onClick={() => handleClick("abrir", "/ordens-servico/abrir-nova-os")}
        aria-label="Abrir Nova OS"
      >
        <span className="m-fab-icon">
          <IconPlus size="28px" color="#fff" />
        </span>
      </button>

      {/* Atendimentos (some para Cliente) */}
      {!flags.isCliente && (
        <button
          className={`m-bottom-btn ${abaAtiva === "atend" ? "ativo" : ""} ${
            ripple === "atend" ? "ripple" : ""
          }`}
          onClick={() => handleClick("atend", "/gerenciar/meus-atendimentos")}
        >
          <span className="m-bottom-icon">
            <IconTool size="22px" />
          </span>
          <span className="m-bottom-label">Atend.</span>
          {renderBadge(badges.atend)}
        </button>
      )}

      {/* Compras (some para Cliente) */}
      {!flags.isCliente && (
        <button
          className={`m-bottom-btn ${abaAtiva === "compras" ? "ativo" : ""} ${
            ripple === "compras" ? "ripple" : ""
          }`}
          onClick={() => handleClick("compras", "/estoque/pedidos-pecas")}
        >
          <span className="m-bottom-icon">
            <IconCart size="22px" />
          </span>
          <span className="m-bottom-label">Compras</span>
          {renderBadge(badges.compras)}
        </button>
      )}
    </nav>
  );
}

export default BottomBar;
